import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistorytaskAttachmentSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <path
          d="M19.5757 18.3306C19.4128 18.3306 19.2499 18.2681 19.1258 18.144C18.8769 17.8952 18.8769 17.493 19.1258 17.2442L20.8218 15.5482C21.4074 14.9683 21.7288 14.1931 21.7288 13.3639C21.7288 11.6596 20.3419 10.2729 18.6376 10.2729C17.809 10.2729 17.0338 10.5943 16.4553 11.1779L14.7574 12.8759C14.5086 13.1247 14.1063 13.1247 13.8575 12.8759C13.6087 12.6269 13.6087 12.2248 13.8575 11.9759L15.5535 10.2799C16.3707 9.45506 17.4666 9 18.6376 9C21.0439 9 23.0015 10.9576 23.0015 13.3639C23.0015 14.5356 22.5465 15.6315 21.7192 16.4506L20.0251 18.144C19.901 18.2681 19.7386 18.3306 19.5757 18.3306Z"
          fill={fill}
        />
        <path
          d="M13.3639 22.9986C10.9576 22.9986 9 21.041 9 18.6347C9 17.4631 9.45506 16.3671 10.2824 15.5481L11.9766 13.8546C12.2254 13.6058 12.6276 13.6058 12.8764 13.8546C13.1252 14.1034 13.1252 14.5056 12.8764 14.7544L11.1804 16.4506C10.5943 17.0303 10.2729 17.8055 10.2729 18.6347C10.2729 20.339 11.6596 21.7258 13.3639 21.7258C14.1926 21.7258 14.9677 21.4044 15.5462 20.8209L17.2442 19.1229C17.493 18.874 17.8952 18.874 18.144 19.1229C18.393 19.3717 18.393 19.7739 18.144 20.0227L16.448 21.7189C15.6309 22.5435 14.5349 22.9986 13.3639 22.9986Z"
          fill={fill}
        />
        <path
          d="M13.4549 19.1807C13.292 19.1807 13.1291 19.1184 13.005 18.9943C12.7562 18.7455 12.7562 18.3432 13.005 18.0944L18.0964 13.003C18.3452 12.7542 18.7474 12.7542 18.9962 13.003C19.2451 13.2519 19.2451 13.6541 18.9962 13.9029L13.9048 18.9943C13.7808 19.1184 13.6178 19.1807 13.4549 19.1807Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default TaskHistorytaskAttachmentSVG;
